import React from 'react';
import { FormattedMessage } from 'react-intl';

import Layout from '../components/en';
import SEO from '../components/seo';

const Success = () => (
  <Layout location={typeof window !== 'undefined' ? location : null}>
    <SEO
      title="Success"
      description="Success confirmation - Furlan Snowboards"
      pathname="/en/success/"
      keywords={['snowboard', 'boards', 'versatility']}
    />
    <div className="successPage">
      <header className="masthead">
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-lg-7 my-auto">
              <div className="header-content mx-auto">
                <h1 className="mb-3">Your request has been sent !</h1>
                <p className="lead mb-5">We will get back to you shortly</p>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  </Layout>
);

export default Success;
